import { AAxisIcon, CAxisIcon } from '@/icons';
import { JogButton } from '@/components/jog/JogButton';
import { useJog } from '@/components/jog/useJog';
import { AXIS_INDEX } from '@/types/machine.types';
import styles from '@/components/jog/jog.module.css';

interface RotaryPillProps {
  axisIndex: number;
  minusLabel: string;
  plusLabel: string;
  glyph: JSX.Element;
  disabled: boolean;
  onStart: (axisIndex: number, dir: 1 | -1) => void;
  onStop: (axisIndex: number) => void;
}

function RotaryPill({
  axisIndex,
  minusLabel,
  plusLabel,
  glyph,
  disabled,
  onStart,
  onStop,
}: RotaryPillProps): JSX.Element {
  return (
    <div className={styles.rotaryPill}>
      <JogButton
        label={minusLabel}
        axisIndex={axisIndex}
        direction={-1}
        disabled={disabled}
        className={styles.rotaryJogBtn}
        onStart={onStart}
        onStop={onStop}
      />
      {glyph}
      <JogButton
        label={plusLabel}
        axisIndex={axisIndex}
        direction={1}
        disabled={disabled}
        className={styles.rotaryJogBtn}
        onStart={onStart}
        onStop={onStop}
      />
    </div>
  );
}

/** Rotary axis (A / C) jog pills. Self-contained / reusable. */
export function RotaryControls(): JSX.Element {
  const { estop, onStart, onStop } = useJog();

  return (
    <>
      <div className={styles.rotaryDivider}>
        <span className={styles.rotaryDividerLabel}>Rotary</span>
      </div>
      <div className={styles.rotaryAxes}>
        <RotaryPill
          axisIndex={AXIS_INDEX.A}
          minusLabel="A-"
          plusLabel="A+"
          glyph={<AAxisIcon className={styles.rotaryGlyph} aria-hidden="true" />}
          disabled={estop}
          onStart={onStart}
          onStop={onStop}
        />
        <RotaryPill
          axisIndex={AXIS_INDEX.C}
          minusLabel="C-"
          plusLabel="C+"
          glyph={<CAxisIcon className={styles.rotaryGlyph} aria-hidden="true" />}
          disabled={estop}
          onStart={onStart}
          onStop={onStop}
        />
      </div>
    </>
  );
}
